export enum Country {
  US = 'us',
  Canada = 'ca',
  UK = 'gb',
  France = 'fr',
  India = 'in',
  Ukraine = 'ua',
  Australia = 'au',
  NewZealand = 'nz',
  Brazil = 'br'
}
